//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    status: {
      type: String,
      required: true
    },
  },

  data() {
    return {
      status_: this.status,
      options: [
        {
          value: 'activo',
          caption: "El promotor aprobó nuestras validaciones exitosamente.",
        },
        {
          value: 'pendiente',
          caption: "Default. El promotor terminó el registro inicial.",
          disabled: true,
        },
        {
          value: 'manual',
          caption: "Se requiere revisar la información del promotor por un operador.",
        },
        {
          value: 'desactivado',
          caption: "El promotor está suspendido, pero aún puede acceder a su cuenta.",
        },
      ],
      loading: false,
    }
  },

  methods: {
    show() {
      this.$refs.dialog.show()
    },
    hide() {
      this.$refs.dialog.hide()
    },
    submit() {
      this.$emit('ok', this.status_)
    }
  }
}
